import { BoxV2 as Box, Flex } from 'portal-commons';
import { CSSProperties, FunctionComponent } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface HeadingBlockProps {
  style?: CSSProperties;
  icon: IconProp;
  title: string;
}

const HeadingBlock: FunctionComponent<HeadingBlockProps> = ({
  style,
  icon,
  title,
  children,
}) => {
  return (
    <div className="heading-block" style={style}>
      <Flex sx={{ alignItems: 'center' }}>
        <Box sx={{ mr: 'xs' }}>
          <FontAwesomeIcon icon={icon} size="xl" color="#49535D" />
        </Box>
        <h3 className="heading1">{title}</h3>
      </Flex>
      {children}
    </div>
  );
};

export default HeadingBlock;
